<div class="offcanvas-header" #header>
    <h5 class="offcanvas-title">SmartQuote Favourites</h5>
    <button type="button" class="btn-close text-reset" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="offcanvas-body overflow-auto" style="max-height: 90vh">
    <div class="row">
        <div class="col-12">
            <sf-callout
                >Reduce time finding products, add products from the wolseley catalog to your favourites to quickly find
                the parts you need.</sf-callout
            >
        </div>
    </div>

    @if (favourites$ | async; as favouritesPaged) {
        @if (favouritesPaged.totalItemCount === 0) {
            <p>
                You don't have any favourites yet, go to
                <a routerLink="admin/smartquote-favourites">SmartQuote Favourites</a> to add some.
            </p>
        }

        <div class="mb-2">
            @if (productsSearchedHasImages) {
                <button
                    sfButton
                    size="sm"
                    color="secondary"
                    icon="camera"
                    [active]="showImages"
                    (click)="showImages = !showImages">
                    {{ showImages ? 'Hide' : 'Show' }} Images
                </button>
            }
            <button
                sfButton
                *ngxPermissionsOnly="'Wolseley'"
                size="sm"
                color="secondary"
                icon="pound-sign"
                [active]="includeTerms"
                [disabled]="includeTerms"
                (click)="onIncludeTermsChanged()">
                Include Terms
            </button>
        </div>

        <sf-list-selector [options]="favouritesPaged.items" (selectionChanged)="onSelectFavourite($event)">
            <ng-template [options]="favouritesPaged.items" let-item>
                <p class="mb-0 fw-bold">
                    @if (item.imageUrl) {
                        <fa-icon [icon]="['fas', 'camera']"></fa-icon>
                    }
                    {{ item.name }}
                </p>
                <div class="d-flex mt-2">
                    <div>
                        @if (item.manufacturerPartNumber) {
                            <span class="small text-muted d-block">MPN: {{ item.manufacturerPartNumber }}</span>
                        }
                        @if (item.catalogNumber) {
                            <span class="small text-muted d-block">Catalog Number: {{ item.catalogNumber }}</span>
                        }
                    </div>
                    <div class="ms-auto text-end">
                        <span class="ms-auto fw-bold text-success d-block">Trade: {{ item.price | currency }}</span>
                        @if (item.terms) {
                            <span class="ms-auto fw-bold text-info d-block">Terms: {{ item.terms | currency }}</span>
                        }
                    </div>
                </div>
                @if (showImages && item.imageUrl) {
                    <img [src]="item.imageUrl" class="img-fluid" style="max-height: 120px" />
                }
            </ng-template>
        </sf-list-selector>

        @if (favouritesPaged.totalItemCount > 0) {
            <ngb-pagination
                class="d-flex justify-content-center mt-3"
                [(page)]="favouritesPaged.pageNumber"
                [pageSize]="favouritesPaged.pageSize"
                [collectionSize]="favouritesPaged.totalItemCount"
                [rotate]="true"
                [ellipses]="false"
                [maxSize]="4"
                size="sm"
                (pageChange)="onPageChange($event)"></ngb-pagination>
        }
    }

    @if (selectedFavourite) {
        <div class="d-grid gap-2 mt-2">
            <button sfButton type="button" color="success" size="lg" icon="check-circle" (click)="confirmPart()">
                Select Part
            </button>
        </div>
    }

    <hr />
    <div class="d-grid gap-2">
        <button sfButton type="button" color="danger" size="lg" (click)="close()">Close</button>
    </div>
</div>
